class TrialCompanyValidation {
    constructor() {
        this.companyValidationFormValidation();
        this.dontHaveWorkEmailFormValidation();
        this.checkUrlForOpenVerifyEmail();
    }
    companyValidationFormValidation(){
        let form = document.getElementById('frm-accountVerificationForm-accountVerificationForm');
        if(form){
            let submitButton = document.getElementById('company_validation_form_submit');

            FormValidation.formValidation(
                form,
                {
                    fields: {
                        'Email': {
                            validators: {
                                notEmpty: {
                                    message: 'Email is required'
                                },
                                regexp: {
                                    regexp: /^(?:[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)])$/,
                                    message: 'Please enter a valid email address',
                                },
                                stringLength: {
                                    max: 45,
                                    message: 'Email cannot be over 45 characters',
                                }
                            }
                        },
                        'CompanyName': {
                            validators: {
                                notEmpty: {
                                    message: 'Company name is required'
                                },
                                stringLength: {
                                    max: 128,
                                    message: 'Company name cannot be over 128 characters',
                                },
                            }
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                        icon: new FormValidation.plugins.Icon({
                            valid: 'fa fa-check',
                            invalid: 'fa fa-times',
                            validating: 'fa fa-refresh',
                        }),
                    }
                }
            ).on('core.form.validating', function(event) {
                new DismissModal('company_validation_modal').disable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'on');
                // Disable button to avoid multiple click
                submitButton.disabled = true;
            }).on('core.form.valid', function(e) {
                // Submit form
                form.submit();
            }).on('core.form.invalid', function(event) {
                new DismissModal('company_validation_modal').enable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'off');
                // Disable button to avoid multiple click
                submitButton.disabled = false;
            });
        }
    }
    dontHaveWorkEmailFormValidation(){
        let form = document.getElementById('frm-dontHaveWorkEmailForm-dontHaveWorkEmailForm');
        if(form){
            let submitButton = document.getElementById('dont_have_work_email_form_submit');

            FormValidation.formValidation(
                form,
                {
                    fields: {
                        'companyValidation': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    max: 500,
                                    message: 'Text cannot be over 500 characters',
                                },
                            }
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                        icon: new FormValidation.plugins.Icon({
                            valid: 'fa fa-check',
                            invalid: 'fa fa-times',
                            validating: 'fa fa-refresh',
                        }),
                    }
                }
            ).on('core.form.validating', function(event) {
                new DismissModal('dont_have_work_email_modal').disable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'on');
                // Disable button to avoid multiple click
                submitButton.disabled = true;
            }).on('core.form.valid', function(e) {
                // Submit form
                form.submit();
            }).on('core.form.invalid', function(event) {
                new DismissModal('dont_have_work_email_modal').enable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'off');
                // Disable button to avoid multiple click
                submitButton.disabled = false;
            });
        }
    }
    checkUrlForOpenVerifyEmail(){
        if (window.location.href.indexOf("#verify-your-email") > -1) {
            new bootstrap.Modal(document.getElementById('verify_email_modal'), {}).show();
            history.replaceState(null, "", location.href.split("#")[0]);
        }
    }
}

// On document ready
KTUtil.onDOMContentLoaded(function() {
    new TrialCompanyValidation();
});